module.exports = __webpack_public_path__ + "static/media/logo-light.65f403a3.svg";